export default {
  action: 'Acción',
  actionBlockedDueToDuplicateUuid:
    'Acción bloqueada debido a un UUID de dispositivo duplicado',
  active: 'Activo',
  add: 'Agregar',
  addAnotherIp: 'Agregar otra IP',
  addDeviceHeaderwoSuite: 'Agregar dispositivos: {{screen}}',
  addDevices: 'Agregar dispositivo',
  addIp: 'Agregar IP',
  addIPAddress: 'Agregar dirección IP',
  addIpHeader: 'Agregar dirección IP: {{screen}}',
  addRole: 'Agregar rol',
  addSuite: 'Agregar suite',
  addSuiteHeader: 'Agregar suite: {{screen}} - Suite {{suite}}',
  adminRoleWillHaveFullAccess: 'El rol de administrador tendrá acceso total',
  all: 'Todas',
  and: 'y',
  applianceStatus: 'Estado del dispositivo',
  apply: 'Aplicar',
  assignedToDevice: 'Asignado al dispositivo',
  availableDevices: 'Dispositivos disponibles',
  bookingDate: 'Fecha de reserva',
  bookingRef: 'Nro de Reserva',
  bulkEditScreenIPs: 'Edición masiva de IP de pantalla',
  bulkHeadingMsg:
    'Los cambios realizados en las IP aquí se reflejarán en todos los dispositivos de pantalla asociados.',
  cancel: 'Cancelar',
  ccEmails: 'Correos electrónicos CC',
  certificateAutoSync: 'Sincronización automática de certificados',
  certificateExpired: 'Certificado caducado',
  certificateForAllDevicesMustBeValid:
    'El certificado para todos los dispositivos debe ser válido',
  certificateNotAvailable:
    'Certificado de dispositivo no disponible para este número de serie.',
  certificateNotValid: 'Certificado no válido',
  chain: 'Cadena',
  chainSmall: 'Cadena',
  changesSavedSuccessfully: 'Cambios guardados correctamente',
  clear: 'Borrar',
  clearAll: 'Borrar todo',
  clearAllSmall: 'Borrar todo',
  clearSelection: 'Borrar selección',
  collapseAll: 'Contraer todo',
  common: {
    confirm: 'Confirmar',
  },
  composition: 'Composición',
  compositionCount_one: 'Composición (1)',
  compositionCount_other: 'Composiciones ({{count}})',
  compositionDetails: 'Detalles de composición',
  compositionName: 'Nombre de la composición',
  confirmDelete: 'Confirmar eliminación',
  confirmDeleteIP: '¿Está seguro de que desea eliminar la dirección IP {{ip}}?',
  confirmDeleteIPAssigned:
    'Esta IP está asignada actualmente y se desconectará del dispositivo: {{deviceInfo}} en {{location}}.',
  confirmDeleteSuite:
    '¿Está seguro de que desea eliminar {{screen_name}} - Suite {{suite_number}}? Elija una opción adecuada para continuar.',
  content: 'Contenido',
  contentDetails: 'Detalles del contenido',
  copyLink: 'Copiar enlace',
  countTheatres_one: '1 Cine',
  countTheatres_other: '{{count}} Cines',
  cplMarkers: 'Marcadores CPL',
  create: 'Crear',
  createOn: 'Creado el',
  creditOffset: 'Compensación de crédito',
  creditsOffset: 'Desplazamiento de créditos',
  dcpStatusTitle: 'Estado de DCP',
  deactivatedUser: 'Usuario desactivado',
  delete: 'Eliminar',
  deleteIp: 'Eliminar IP',
  deleteSuite: 'Eliminar suite',
  deleteTheatreGroup: 'Eliminar grupo de cines',
  deleteTheatreGroupConfirmation:
    '¿Está seguro de que desea eliminar {{groupName}}? Esta acción es permanente y no se puede deshacer.',
  deleteTheatreWarningMessage:
    'Eliminarlo afectará su acceso, ¿está seguro de que desea continuar?',
  details: 'Detalles',
  deviceWillBeRemoved: 'El dispositivo se eliminará de esta suite',
  deviceModel: 'Modelo de dispositivo',
  deviceRole: 'Rol del dispositivo',
  devices: 'Dispositivos',
  deviceWillBeMoved:
    'El dispositivo se moverá a la pantalla {{destination}} Dispositivos después de guardar',
  deviceWillBeMovedToStandby: 'El dispositivo se moverá a Standby',
  disabled: 'Deshabilitado',
  doNotIncludePrDevices:
    'NO incluya dispositivos PR para la generación de KDM.',
  downloadAttempt: 'Intento de descarga',
  downloadDetails: 'Descargar detalles',
  downloadHistory: 'Historial de descargas',
  downloadKDMs: 'Descargar KDM',
  downloadLocation: 'Ubicación de descarga',
  downloadNow: 'Descargar ahora',
  downloadProgress: '{{progress}} Completado',
  downloadSize: 'Tamaño de descarga',
  downloadStatus: 'Estado de descarga',
  duplicateDeviceFound: 'Dispositivo duplicado encontrado',
  duplicateDeviceWarning:
    'Dispositivo duplicado encontrado en {{screens_and_suites}}',
  editDevice: 'Editar dispositivo',
  editDeviceMeta: 'Editar metadatos del dispositivo',
  editIp: 'Editar IP',
  editIpHeader: 'Editar IP - Pantalla {{screen}}',
  editRoles: 'Editar roles',
  editSuite: 'Editar suite',
  editSuiteHeader: 'Editar suite: Pantalla {{screen}} - Suite {{suite}}',
  editTheatreGroup: 'Editar grupo de cines',
  effectiveFrom: 'Efectivo desde',
  email: 'Correo electrónico',
  emailKDMS: 'Enviar KDM por correo electrónico',
  emptyScreen: 'No se agregó ninguna suite a la pantalla',
  emptyStandby: 'No hay dispositivos en espera',
  enabled: 'Habilitado',
  enterEmail: 'Introducir correo electrónico',
  enterGateway: 'Introducir puerta de enlace',
  enterIpAddress: 'Introduzca la dirección IP',
  enterSoftwareVersion: 'Introducir versión de software',
  enterSubnetMask: 'Introducir máscara de subred',
  errorDownloadingKDMs: 'Error en la descarga de KDM',
  errorFetching: 'Error al obtener datos',
  errorFetchingDevices: 'Error al obtener dispositivos',
  errorFetchingFilterSettings: 'Error al obtener la configuración del filtro',
  errorFetchingGroups: 'Error al cargar la lista de grupos',
  errorFetchingUser: 'Error al cargar la información del usuario',
  errorFetchingUsersList: 'Error al cargar la lista de usuarios',
  errorFetchingWireTapCount: 'Error al cargar el número total de WireTAPs',
  errorLoadingWireTap: 'Error al cargar WireTAPs',
  errorMessage: 'Se produjo un error al procesar su solicitud',
  errorReportDownload: 'Error al descargar el informe {{report}}: {{error}}',
  errors: {
    fetchDeviceModels: 'Error al obtener modelos de dispositivos',
    fetchDeviceRoles: 'Error al obtener roles de dispositivos',
    fetchTheatreInfo: 'Error al obtener información del cine',
  },
  errorUploadingCertificate: 'Error al cargar el certificado',
  expandAll: 'Expandir todo',
  expired: 'Caducado',
  expiredOn: 'Expiró el',
  expiring: 'Caduca (en {{days}} días)',
  expiring_1: 'Por caducar',
  expiryOn: 'Fecha de caducidad',
  failedToDeleteTheatreGroup: 'Error al eliminar el grupo de cines',
  failedToDeleteTheatreGroupMessage:
    'Se produjo un error al eliminar el grupo de cines',
  failedToRemoveUser: 'Error al eliminar usuario',
  failedToSendUserInvite: 'Error al enviar la invitación al usuario',
  failedToUpdateUser: 'Error al actualizar el usuario',
  fetchCompositions: 'Error al cargar composiciones',
  fetchingRoles: 'Obteniendo roles...',
  fetchTheatres: 'Error al cargar cines',
  filter: 'Filtro',
  filterBy: 'Filtrar por',
  filterByTheatres: 'Filtrar por cines',
  filterPanelCompositionType: 'TIPO DE COMPOSICIÓN',
  filterPanelCompositionTypeOptions_advertisement: 'Anuncio',
  filterPanelCompositionTypeOptions_feature: 'Características',
  filterPanelCompositionTypeOptions_others: 'Otros',
  filterPanelCompositionTypeOptions_psaPolicy: 'PSA/Política',
  filterPanelCompositionTypeOptions_trailerTeaserPromo: 'Tráiler/Teaser/Promo',
  filterPanelDcpDownloadStatus: 'ESTADO DE DESCARGA DE DCP',
  filterPanelDcpIngestStatus: 'ESTADO DE INGESTA DE DCP',
  filterPanelKdmIngestStatus: 'ESTADO DE INGESTA DE KDM',
  filterPanelKdmStatus: 'ESTADO DE ENTREGA DE KDM',
  filterPanelKdmValidity: 'VALIDEZ DE KDM',
  filterPanelTheatresPlaceHolder: 'Buscar cines',
  filterPanelTheatresTitle: 'CINES',
  filters: 'Filtros',
  from_time_of_booking: 'desde el momento de la reserva',
  fullAccess: 'Acceso total',
  future: 'Válido en el futuro',
  gateway: 'Puerta de enlace',
  generateReport: 'Generar informe',
  groupCount_one: '{{count}} Grupo',
  groupCount_other: '{{count}} Grupos',
  groupName: 'Nombre del grupo',
  groupsCreateGroupCancel: 'Cancelar',
  groupsCreateGroupCreateTheatreGroups: 'Crear grupos de cines',
  groupsCreateGroupGroupCreated: 'Grupo creado',
  groupsCreateGroupGroupName: 'Nombre del grupo',
  groupsCreateGroupGroupPlaceHolderName: 'Introduzca el nombre del grupo',
  groupsCreateGroupHeaderTitle: 'Crear grupo',
  groupsCreateGroupSaveChanges: 'Guardar cambios',
  groupsCreateGroupTheatreSelection: 'Selección de cines',
  groupsHeaderCreateTheatreGroupButton: 'Crear grupo de cines',
  groupsHeaderViewLogsButton: 'Ver registros',
  groupUpdated: 'Grupo actualizado',
  holdoverKdmRequests: 'Solicitudes de KDM residuales',
  hour: 'Hora',
  iabScreens: 'Pantallas IAB',
  inbox: 'Bandeja de entrada',
  invalidEmail: 'Dirección de correo electrónico no válida',
  ipRequired: 'La dirección IP es obligatoria',
  ipAddress: 'Dirección IP',
  ipAddress_1: 'DIRECCIÓN IP',
  ipAlreadySelectedInForm:
    'Esta IP ya está seleccionada/asignada. Seleccione otra IP.',
  ipCount_one: 'IPs (1)',
  ipCount_other: 'IPs ({{count}})',
  kdmDetails: 'Detalles de KDM',
  kdmValidityTheatreTimeZone: 'Validez KDM (Zona Horaria del Cine)',
  lastUpdatedBy: 'Última actualización por',
  lastUpdatedOn: 'Última actualización:',
  linkExpiredOnDownload:
    'No se puede iniciar la descarga. El enlace de entrega ha caducado o ya no es elegible para la descarga.',
  linkReceivedOn: 'Enlace recibido el',
  loading: 'Cargando',
  location: 'Ubicación',
  logsTheatreGroups: 'Registros: Grupos de cines',
  minute: 'Minuto',
  moveModalText: 'El dispositivo {{name}} se moverá a Standby, ¿continuar?',
  moveTo: 'Mover a',
  moveToScreen: 'Pantalla {{number}}',
  moveToStandby: 'Mover a Standby',
  moveToStandbyDevices: 'Mover a dispositivos en espera',
  moveToUnmapped: 'Mover a la pantalla {{number}} Dispositivos',
  movie: 'Película',
  movieName: 'Nombre de la película',
  multiThumbprintKdm:
    'Pantallas KDM de huellas dactilares múltiples con servidor DC2 (DCP 2000)',
  multiThumbprintKdmOtherServices:
    'Pantallas KDM de huellas dactilares múltiples con otros servidores',
  name: 'Nombre',
  needs_1_SM_RMB_msg:
    'Cada suite debe contener exactamente 1 SM/1 RMB. Agregue un dispositivo SM/RMB con certificado para continuar',
  newData: 'Nuevos datos',
  newRequestCreated:
    'Se han creado nuevas solicitudes con el ID de solicitud {{requestId}}.',
  no_compositions: 'Sin composiciones',
  no_theatres: 'No hay cines disponibles',
  noAccess: 'Sin acceso',
  noBookings: 'No hay reservas disponibles',
  noData: 'Sin datos',
  noExpiredBookings: 'No se encontraron descargas de WireLink caducadas.',
  noIpFound: 'No hay IP disponibles',
  noMatchFound: 'No se encontraron coincidencias',
  noResultsFound: 'No se encontraron resultados',
  normalKdm: 'KDM normal',
  notDownloaded: 'No descargado',
  notSelected: 'No seleccionado',
  noWiretapAvailable: 'No hay WireTAPs disponibles',
  oldData: 'Datos antiguos',
  optional: 'Opcional',
  osVersion: 'VERSIÓN DEL SISTEMA OPERATIVO',
  pending: 'Pendiente',
  readyToDownload: 'Listo para descargar',
  receivedOn: 'Recibido el',
  recipientDetails: 'Detalles del destinatario',
  recipientEmails: 'Correos electrónicos del destinatario',
  remove: 'Eliminar',
  removeFromTheatre: 'Eliminar del cine',
  removeModalText: '¿Está seguro de que desea eliminar {{name}} del cine?',
  removeUser: 'Eliminar usuario',
  removeUserConfirmation:
    'Al eliminar a este usuario se le quitará el acceso a esta empresa. El usuario no podrá iniciar sesión ni realizar ninguna acción.',
  reportInitiated: '{{report}} ha sido iniciado.',
  reportReady: '{{report}} está listo.',
  reportsheaderTitle: 'Informes',
  requestedBy: 'Solicitado por',
  requestedKdmValidity: 'Validez de KDM solicitada',
  requestedOn: 'Solicitado en',
  requestFailed: 'Solicitud fallida',
  requestFailedMessage: 'No se pudo enviar la solicitud. Inténtelo de nuevo.',
  requestSent: 'Solicitud enviada',
  role: 'Rol',
  roles: 'Roles',
  save: 'Guardar',
  saveChanges: 'Guardar cambios',
  screen: 'Pantalla',
  screenInactive: 'Inactivo',
  screens: 'Pantallas',
  searchByLocation: 'Buscar por ubicación',
  searchByNameOrEmail: 'Buscar por nombre o correo electrónico',
  searchBySerialNo: 'Buscar por número de serie',
  searchByTheatreGroup: 'Buscar por grupo de cines',
  searchByTheatreGroupName: 'Buscar por nombre del grupo de cines',
  searchByTheatreName: 'Buscar por nombre del cine',
  searchCompositions: 'Buscar por nombre de la composición',
  searchCompositionsPlaceholder: 'Buscar composiciones',
  searchDeviceModel: 'Buscar modelo de dispositivo',
  searchForChain: 'Buscar cadena',
  searchForLocation: 'Buscar ubicación',
  searchForOsVersion: 'Buscar versión del sistema operativo',
  searchForPublicIp: 'Buscar IP pública',
  searchForSerialNumber: 'Buscar número de serie',
  searchForTheatre: 'Buscar cines',
  searchForWiretap: 'Buscar WireTAP',
  searchMovies: 'Buscar por nombre de película',
  searchPlaceholder: 'Busque los cines que administra',
  searchSerialNumber: 'Buscar número de serie',
  searchTheatres: 'Buscar por nombre de cine',
  selectIpAddress: 'Seleccionar dirección IP',
  selectRole: 'Seleccionar rol',
  sendInvite: 'Enviar invitación',
  serialNumber: 'Número de serie',
  serialNumber_1: 'NÚMERO DE SERIE',
  show: 'Mostrar',
  showingCountResults_one: 'Mostrando 1 resultado para',
  showingCountResults_other: 'Mostrando {{count}} resultados para',
  showingResults: 'Mostrando {{start}}-{{end}} de {{total}} elementos',
  showingResultsFor: 'Mostrando resultados para',
  showMore: 'Mostrar más',
  softwareVersion: 'Versión del software',
  somethingWentWrong: '¡Algo salió mal!',
  standby: 'En espera',
  standbyDevices: 'Dispositivos en espera',
  standbyHeader_one: 'Dispositivos en espera (1)',
  standbyHeader_other: 'Dispositivos en espera ({{count}})',
  status: 'Estado',
  subnetMask: 'Máscara de subred',
  suite: 'Suite',
  suiteCreationRules: 'Reglas de creación de suites',
  suiteDevicesExpiredMsg:
    'La suite tiene dispositivos con certificados caducados',
  suiteEffectiveFrom: 'Suite efectiva desde',
  suiteInvalid: 'Suite no válida para la generación de KDM',
  suiteLogs: 'Registros de la suite',
  suiteMustContain:
    'La suite debe contener exactamente {{smCount}} dispositivo SM o {{rmbCount}} dispositivo RMB.',
  suiteMustContainAdLd:
    'La suite debe contener al menos 1 dispositivo adicional con el rol de dispositivo como LD',
  suiteMustContainLDorPR:
    'La suite debe contener al menos 1 dispositivo adicional con el rol de dispositivo como LD o PR.',
  suiteMustContainSm:
    'La suite debe contener exactamente {{smCount}} dispositivo SM.',
  suiteMustContainSMOBE:
    'La suite debe contener exactamente 1 SM / OBAE con dispositivo SM.',
  suiteNo: 'Suite {{number}}',
  theatre: 'Cine',
  theatre_1: 'CINE',
  theatre_header: 'Cine',
  theatreCount: 'Recuento de cines',
  theatreGroup: 'Grupo de cines',
  theatreGroupDeleted: 'Grupo de cines eliminado',
  theatreGroupDeletedMessage: '{{groupName}} fue eliminado',
  theatreGroupDetails: 'Detalles del grupo de cines',
  theatreGroups: 'Grupos de cines',
  theatreName: 'Nombre del cine',
  theatres: 'Cines',
  theatresList: 'Lista de cines',
  theatreSmall: 'Cine',
  theatreTimeZone: 'Zona horaria del cine',
  trackingInfo: 'Información de seguimiento',
  unarchival_may_take: 'El desarchivo puede tardar',
  undo: 'Deshacer',
  unmappedDevices_one: 'Dispositivo (1)',
  unmappedDevices_other: 'Dispositivos ({{count}})',
  untitled: 'Sin título',
  update: 'Actualizar',
  updatedBy: 'Actualizado por',
  updatedOn: 'Actualizado el',
  uploadCertificate: 'Cargar certificado',
  uploadDeviceCertificate: 'Cargar certificado de dispositivo',
  user: 'Usuario',
  userCount_one: '{{1}} Usuario',
  userCount_other: '{{count}} Usuarios',
  userInviteSent: 'Invitación de usuario enviada correctamente',
  userLogs: 'Registros de usuario',
  userRemoved: 'Usuario eliminado',
  users: 'Usuarios',
  usersHeaderButtonsInviteUser: 'Invitar usuario',
  usersHeaderButtonsViewLogs: 'Ver registros',
  usersHeaderTitle: 'Administrar usuarios',
  validFrom: 'Válido desde',
  validNow: 'Válido ahora',
  validTo: 'Válido para',
  verificationStatus: 'Estado de verificación',
  viewAll: 'Ver todo',
  viewAllTheatreGroups: 'Ver todos los grupos de cines',
  viewCreditOffset: 'Créditos: {{value}}',
  viewSuiteLogs: 'Ver registros de suite',
  viewTheatreGroup: 'Ver grupo de cines',
  warning: 'Advertencia',
  wireLinkCopiedToClipboard: 'WireLink copiado al portapapeles',
  wireLinkCopyFailed: 'No se pudo copiar, inténtelo de nuevo',
  wireLinkDetails: 'Detalles de WireLink',
  wireLinks: 'WireLinks',
  wiretaps: 'WireTAPs',
  wiretapStatusReport: 'Informe de estado de WireTAP',
  removeDevice: 'Eliminar dispositivo',
  deleteIpTitle: 'Eliminar dirección IP - {{ip}}',
  appliances: 'Aparatos',
  noResultsFor: 'No hay resultados para',
  city: 'Ciudad',
  province: 'Provincia',
  country: 'País',
  confirmAction: 'Confirmar acción',
  RequestId: 'ID de solicitud: {{requestId}}',
  moveToUnmapped_name: 'Mover a dispositivos {{name}}',
  language: 'Idioma',
  subtitleLanguage: 'Idioma de subtítulos',
  mainCaption: 'Subtítulo principal',
  ratings: 'Calificaciones',
  type: 'Tipo',
  dciStandard: 'Estándar DCI',
  closedSubtitles: 'Subtítulos cerrados',
  frameRate: 'Velocidad de fotogramas',
  audioFormats: 'Formatos de audio',
  resolution: 'Resolución',
  closedCaptions: 'Subtítulos cerrados',
  stereoType: 'Tipo de estéreo',
  aspectRatio: 'Relación de aspecto',
};
